<template>
    <div class="modal-profile-advert-popup" v-if="displayAdvert">
        <div class="modal-profile-advert-popup-content">
            <div class="modal-profile-advert-popup-ad">
                <!--    page 2 to disable placeholder of page 1      -->
                <NativeAdInSearchComponent
                    :advert="displayAdvert"
                    :current-page="2"
                    :from-profile="true"
                />
            </div>

            <button
                class="modal-profile-advert-popup-skip"
                :disabled="countdown > 0"
                @click="onSkipAd"
            >
                {{ skipButtonText }}
            </button>

            <button
                class="modal-profile-advert-popup-upgrade"
                @click="onUpgradeVipClick"
            >
                {{ translate.home.profileAdvertPopUp.upgradeToVIP }}
            </button>

            <div class="modal-profile-advert-popup-text">
                {{ translate.home.profileAdvertPopUp.limitReached }}
                {{ translate.home.profileAdvertPopUp.upgradeToVIPToHideAds }}
            </div>
        </div>
    </div>
</template>

<script>
import NativeAdInSearchComponent from "@/components/search/partials/adverts/NativeAdInSearchComponent.vue";
import translateMixin from "@/components/mixins/translateMixin";
import userMixin from "@/components/mixins/userMixin";
import xtrackingMixin from "@/components/mixins/xtrackingMixin";
import {disableScroll, enableScroll} from "@/core/utils/helpers/GlobalCssHelpers";
import {regionRelativeUrl} from "@/core/utils/helpers/regions/regionUrlHelper";
import localStorageMixin from "@/components/mixins/localStorageMixin";

const data = () => ({
    countdown: 5,
    intervalId: null,
    displayAdvert: null,
});

function mounted() {
    const advert = this.pickRandomNativeAd();

    if (!advert) {
        this.onSkipAd();
        return;
    }

    this.displayAdvert = advert;

    /**
     * we need this to trigger watcher and observer in NativeAdInSearchComponent
     */
    this.$nextTick(() => {
        this.displayAdvert = {...advert};
    });

    disableScroll();
    this.captureTrackingEvent(this.currentUser, 'profile', 'enquiry-interstitial', 'open');
    this.startCountdown();
}

function beforeDestroy() {
    if (this.intervalId) {
        clearInterval(this.intervalId);
    }

    enableScroll();
}

function pickRandomNativeAd() {
    if (!this.adverts || this.adverts.length < 1) {
        return null;
    }

    const nativeAds = this.adverts.filter(advert => advert.isNativeAd);
    if (nativeAds.length < 1) {
        return null;
    }

    return nativeAds[Math.floor(Math.random() * nativeAds.length)];
}

function startCountdown() {
    this.intervalId = setInterval(() => {
        if (this.countdown > 0) {
            this.countdown--;
        } else if (this.intervalId) {
            clearInterval(this.intervalId);
        }
    }, 1000);
}

function onSkipAd() {
    this.$emit('skip');
}

function onUpgradeVipClick() {
    this.captureTrackingEvent(this.currentUser, 'profile', 'enquiry-interstitial', 'go-ad-free-click');

    if (this.isLoggedIn) {
        this.setPaymentRedirectLink(window.location.href);
        window.location.href = regionRelativeUrl('/users/products/punter-vip');
        return;
    }

    this.$emit('close');
    $('#modalNotLoggedIn').modal().show();
}

export default {
    data,
    mounted,
    computed: {
        ...mapState(['translate', 'currentUser']),
        skipButtonText() {
            if (this.countdown > 0) {
                return this.countdown.toString();
            }

            return this.translate.home.profileAdvertPopUp.skipAd;
        },
    },
    components: {NativeAdInSearchComponent},
    mixins: [translateMixin, userMixin, xtrackingMixin, localStorageMixin],
    props: {
        adverts: {
            type: Array,
            default: () => [],
        },
    },
    beforeDestroy,
    methods: {
        pickRandomNativeAd,
        startCountdown,
        onSkipAd,
        onUpgradeVipClick,
    },
};
</script>
